const state = {
    profitLossItem: null,
    statementItem: null,
    viewBetsItem:null,
    selectedMatch:null,
    plFilterOption: null

};
const getters = {
    profitLossItem: state => state?.profitLossItem,
    statementItem: state => state?.statementItem,
    viewBetsItem: state => state?.viewBetsItem,
    selectedMatch: state => state?.selectedMatch,
    plFilterOption: state => state?.plFilterOption,   
};
const actions = {
    setProfitLossItem({ commit }, profitLossItem) {
        commit('setProfitLossItem', profitLossItem);
    },
    setStatementItem({ commit }, statementItem) {
        commit('setStatementItem', statementItem);
    },
    setViewBetsItem({ commit }, viewBetsItem) {
        commit('setViewBetsItem', viewBetsItem);
    },
    setSelectedMatch({ commit }, selectedMatch) {
        commit('setSelectedMatch', selectedMatch);
    },
     setPlFilterOption({ commit }, plFilterOption) {
        commit('setPlFilterOption', plFilterOption);
    },
};
const mutations = {
    setProfitLossItem(state, profitLossItem) {
        state.profitLossItem = profitLossItem;
    },
    setStatementItem(state, statementItem) {
        state.statementItem = statementItem;
    },
    setViewBetsItem(state, viewBetsItem) {
        state.viewBetsItem = viewBetsItem;
    },
    setSelectedMatch(state, selectedMatch) {
        state.selectedMatch = selectedMatch;
    },
    setPlFilterOption(state, plFilterOption) {
        state.plFilterOption = plFilterOption;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};